import ConnectExternalPrinterHandler from './handlers/ConnectExternalPrinterHandler';
import ConnectInnerPrinterHandler from './handlers/ConnectInnerPrinterHandler';
import PrintersUpdatedHandler from './handlers/PrintersUpdatedHandler';

const Empty = { type: '', payload: null };

function parseMessage(data) {
  let message = data;

  if (typeof message === 'string') {
    try {
      message = JSON.parse(message);
    } catch {
      return Empty;
    }
  }

  return typeof message?.type === 'string' ? message : Empty;
}

export default class RNWebviewResolver {
  data = Empty;

  constructor(data) {
    this.data = parseMessage(data);
  }

  resolve() {
    switch (this?.data?.type) {
      case ConnectInnerPrinterHandler.type:
        new ConnectInnerPrinterHandler(this.data?.payload).notify();
        break;
      case ConnectExternalPrinterHandler.type:
        new ConnectExternalPrinterHandler(this.data?.payload).notify();
        break;
      case PrintersUpdatedHandler.type:
        new PrintersUpdatedHandler(this.data?.payload).notify();
        break;
      default:
        break;
    }
  }
}
